import { render, staticRenderFns } from "./RecentItemsMenu.vue?vue&type=template&id=01c29980"
import script from "./RecentItemsMenu.vue?vue&type=script&lang=js"
export * from "./RecentItemsMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports